module.exports = __webpack_public_path__ + "img/amare-kyani-logo.34f5b6df.svg";